export const adjustContainerHeightFor = (flexyInstance) => {
  if (!flexyInstance.options.adjustHeight) return

  let currentChild =
    flexyInstance.sliderContainer.children[
      flexyInstance.state.previousCurrentIndex
    ]

  flexyInstance.sliderContainer.style.setProperty(
    "--sliderHeight",
    `${
      (currentChild.firstElementChild || currentChild).getBoundingClientRect()
        .height
    }px`
  )
}
